// extracted by mini-css-extract-plugin
export default {"header":"Reports_header__3QDPs","mobileHeader":"Reports_mobileHeader__ceiNv"};